import {Http} from './http';

export default {
    general: {
        headed: function(){
            return Http.post("/gaceta/headpage");
        }
    },
    predial: {
        liquidacion: function(npn){
            return Http.post("/pse/liqpredial", {npn: npn});
        },
        pdfLiquidacion: function(codLiq){
            return Http.post("/pse/pdfpredial", {liq: codLiq});
        }
    },
    inyco: {
        liquidacion: function(mm){
            return Http.post("/pse/liqinco", {mm: mm});
        },
        liquidacionMMLiq: function(params) {
            return Http.post("/pse/liqincoMMLiq", params);
        },
        pdfLiquidacion: function(codLiq){
            return Http.post("/pse/pdfinco", {liq: codLiq});
        }
    },
    pse:{
        getHead: function(){
            return Http.post("/pse/headpage");
        },
        toPSE: function(data){
            return Http.post("/pse/topse", data);
        },
        validatePSE: function(data){
            return Http.post("/pse/validate", data);
        }
    }
}